export default "__VITE_ASSET__CCq2tD_J__"